import { ROOM_ID_BYTES, ROOM_SECRET_BYTES } from './constants';

export interface Invite {
  roomId: string;
  secret: string;
}

function randomBase64Url(byteLength: number): string {
  const bytes = crypto.getRandomValues(new Uint8Array(byteLength));
  let binary = '';
  for (const byte of bytes) binary += String.fromCharCode(byte);
  return btoa(binary).replaceAll('+', '-').replaceAll('/', '_').replace(/=+$/u, '');
}

export function createInvite(): Invite {
  return { roomId: randomBase64Url(ROOM_ID_BYTES), secret: randomBase64Url(ROOM_SECRET_BYTES) };
}

export function inviteUrl(invite: Invite, origin = window.location.origin): string {
  return `${origin}/room/${invite.roomId}#${invite.secret}`;
}

export function parseInvite(locationLike: Pick<Location, 'pathname' | 'hash'> = window.location): Invite | null {
  const match = locationLike.pathname.match(/^\/room\/([A-Za-z0-9_-]{20,32})\/?$/u);
  const secret = locationLike.hash.replace(/^#/u, '');
  if (!match || !/^[A-Za-z0-9_-]{40,60}$/u.test(secret)) return null;
  return { roomId: match[1], secret };
}
